var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"left-area-item"},[_c('span',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('br'),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.formatThousand(_vm.value)))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }